class APIS {
	apis() {
		return {
			add: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/config/add'
			},
			detail: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/config/detail'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/config/update'
			},
			toggle: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/config/toggle'
			}
		};
	}
}

export default new APIS();
